import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function MessageCard(props) {
  const { classes, icon, iconColour, children } = props;

  const Icon = icon;

  return (
    <Card>
      <CardContent>
        <div className={classes.root}>
          {icon && (
            <Icon className={classes.icon} style={{ color: iconColour }} />
          )}
          <Typography
            component='p'
            variant='body2'
            className={classes.cardNote}
          >
            {children}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
}

MessageCard.propTypes = {
  classes: PropTypes.object.isRequired,
  icon: PropTypes.func,
  iconColour: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.element,
  ]),
};

MessageCard.defaultProps = {
  iconColour: '#f5ba16',
  icon: null,
};

export default withStyles(styles)(MessageCard);
